const scriptUrls: Record<string, string> = {
    audi: 'https://eucdn.whatfix.com/prod/7ca3a171-5725-4025-a35b-b2dd181c3885/initiator/initiator.nocache.js',
    vw: 'https://eucdn.whatfix.com/prod/e64a738d-3550-4573-927d-a9437db3d27b/initiator/initiator.nocache.js',
    vwn: 'https://eucdn.whatfix.com/prod/f89ab93e-2815-409e-8da4-c102a679f2e0/initiator/initiator.nocache.js',
}

const PSEUDONYM_STORAGE_KEY = 'whatfix_user_pseudonym'

let previousBrand: string | undefined

export function getWhatfixSessionPseudonym(): string {
    const stored = sessionStorage.getItem(PSEUDONYM_STORAGE_KEY)
    if (stored) {
        return stored
    }

    const generated = (crypto as Crypto & { randomUUID(): string }).randomUUID()
    sessionStorage.setItem(PSEUDONYM_STORAGE_KEY, generated)
    return generated
}

function addWhatfixScript(url: string): void {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = url
    document.head.appendChild(script)
}

function isWhatfixScriptAlreadyAdded(brand: string): boolean {
    const url = scriptUrls[brand]
    if (!url) {
        return false
    }
    return !!document.querySelector(`script[src="${url}"]`)
}

export function hasBrandScript(brand: string): boolean {
    return brand in scriptUrls
}

export function setWhatfixContext(
    market: string,
    language: string,
    roles: string[],
    pseudonym: string,
): void {
    window.WHATFIX_MARKET = market
    window.WHATFIX_ROLES = roles
    window.WHATFIX_USER_PSEUDONYM = pseudonym
    window.WHATFIX_LANGUAGE = language
}

export function loadWhatfixScript(brand: string): void {
    if (brand !== previousBrand) {
        previousBrand = brand

        if (isWhatfixScriptAlreadyAdded(brand)) {
            window.location.reload()
            return
        }

        const url = scriptUrls[brand]
        if (!url) {
            return
        }
        addWhatfixScript(url)
    }
}
